import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { string, bool, func } from 'prop-types';

const StyledDialogTitle = styled(DialogTitle)(() => ({
  backgroundColor: '#ff4635'
}));

const DeleteTitle = styled(Typography)(() => ({
  fontSize: '1.25rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 500,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  whiteSpace: 'pre-wrap'
}));

const DeleteContactDialog = props => {
  const {
    dialogContentText,
    open,
    onClose,
    onDelete
  } = props;

  const handleOk = () => {
    onDelete();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <StyledDialogTitle id="alert-dialog-title">
        <DeleteTitle>
          {dialogContentText}
        </DeleteTitle>
      </StyledDialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} variant="outlined" color="primary" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteContactDialog.propTypes = {
  dialogContentText: string.isRequired,
  open: bool.isRequired,
  onClose: func.isRequired,
  onDelete: func.isRequired
};

export default DeleteContactDialog;
